import React from 'react'
import ui from 'redux-ui'
import { Segment } from "semantic-ui-react";
import { Button, Checkbox, Form, Header, Icon, Modal } from 'semantic-ui-react'
import { Modal as StoreModal } from 'semantic-ui-react-with-store'

class DossierExportModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = { withNotes: true, withAttachments: false }
  }

  handleNotesChange = (e, { checked }) => {
    this.setState((prevState) => ({
      withNotes: checked,
      withAttachments: checked ? prevState.withAttachments : false
    }))
  }

  handleAttachmentsChange = (e, { checked }) => {
    this.setState({ withAttachments: checked })
  }

  handleConfirm = () => {
    const { dossierId } = this.props
    const { withNotes, withAttachments } = this.state

    if (!dossierId) return

    const format = withAttachments ? 'zip' : 'pdf'
    const href = Routes.export_api_dossier_path({
      id: dossierId,
      format,
      with_notes: withNotes,
      with_attachments: withAttachments,
      _options: true
    })

    window.location.href = href
    this.props.updateUI('open', false)
  }

  render() {
    const { trigger, ui, updateUI } = this.props
    const { withNotes, withAttachments } = this.state

    return (
      <StoreModal
        size="tiny"
        trigger={trigger}
        closeIcon
        open={ui.open}
        onClose={() => updateUI('open', false)}
        onOpen={() => updateUI('open', true)}
      >
        <Header content={I18n.t('components.dossier.export.export_pdf')} />
        <Modal.Content>
          <p>{I18n.t('components.dossier.export.explanation')}</p>
          <Form>
            <Form.Field>
              <Checkbox
                label={I18n.t('components.dossier.export.with_notes')}
                checked={withNotes}
                onChange={this.handleNotesChange}
              />
            </Form.Field>
            {withNotes &&
             <Form.Field style={{ marginLeft: '2rem' }}>
              <Checkbox
                label={I18n.t('components.dossier.export.with_attachments')}
                checked={withAttachments}
                onChange={this.handleAttachmentsChange}
              />
            </Form.Field>}
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button color="green" onClick={this.handleConfirm}>
            <Icon name="download" /> {I18n.t('components.dossier.export.export_button')}
          </Button>
        </Modal.Actions>
      </StoreModal>
    )
  }
}

export default ui({ state: { open: false } })(DossierExportModal)
